"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getDowngradeValues: ()=>getDowngradeValues
});
const getDowngradeValues = (search)=>{
    if (!search) return [];
    const searchParams = 'string' == typeof search ? new URLSearchParams(search) : search;
    const allValues = searchParams.getAll('downgrade');
    const result = [];
    return result.concat(...allValues.map((value)=>value.split(',')));
};
exports.getDowngradeValues = __webpack_exports__.getDowngradeValues;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getDowngradeValues"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
